import { useState } from 'react';
import { uploadToR2, uploadMultipleToR2 } from '@/lib/r2Upload';

/**
 * React hook for handling R2 uploads with loading and error states
 */
export function useR2Upload() {
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState({ current: 0, total: 0 });
  const [error, setError] = useState(null);

  /**
   * Upload a single file to R2
   */
  const uploadSingle = async (file, token) => {
    setUploading(true);
    setError(null);
    setProgress({ current: 0, total: 1 });

    try {
      const url = await uploadToR2(file, token);
      setProgress({ current: 1, total: 1 });
      setUploading(false);
      return url;
    } catch (err) {
      setError(err.message);
      setUploading(false);
      throw err;
    }
  };

  /**
   * Upload multiple files to R2
   */
  const uploadMultiple = async (files, token) => {
    if (!files || files.length === 0) {
      return [];
    }

    setUploading(true);
    setError(null);
    setProgress({ current: 0, total: files.length });

    try {
      const urls = await uploadMultipleToR2(files, token, (current, total) => {
        setProgress({ current, total });
      });

      setUploading(false);
      return urls;
    } catch (err) {
      setError(err.message);
      setUploading(false);
      throw err;
    }
  };

  /**
   * Reset the hook state
   */
  const reset = () => {
    setUploading(false);
    setProgress({ current: 0, total: 0 });
    setError(null);
  };

  return {
    uploading,
    progress,
    error,
    uploadSingle,
    uploadMultiple,
    reset
  };
}
